import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterFactoryVed = _resolveComponent("FilterFactoryVed")!
  const _component_FilterDetailsVed = _resolveComponent("FilterDetailsVed")!

  return (_openBlock(), _createBlock(_component_FilterDetailsVed, null, {
    default: _withCtx(() => [
      _createVNode(_component_FilterFactoryVed, {
        filtersConfig: _ctx.getFiltersConfig,
        onSearchFilter: _ctx.searchFilter,
        onUpdateFilter: _ctx.updateFilter,
        defaultFilter: _ctx.defaultFilter,
        readonlyPermissionCode: _ctx.readonlyPermissionCode
      }, null, 8, ["filtersConfig", "onSearchFilter", "onUpdateFilter", "defaultFilter", "readonlyPermissionCode"])
    ]),
    _: 1
  }))
}